var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-title"
  }, [_vm._v("\n  " + _vm._s(_vm.name) + "\n")])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02b740f2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarNavTitle.vue
// module id = 513
// module chunks = 2